<!-- 快递公司 -->
<template>
  <BaseFormItem2
    class="express"
    :label="fields.label"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <template slot="labelExtend">
      <div v-if="weight" class="express__labelExtend">
        预估重量：{{ weight }}KG
      </div>
    </template>
    <ExpressList2 
      ref="expressListRef"
      class="express-list"
      :isError="isError"
      v-bind="$attrs"
      v-on="$listeners"
      @change="handleChange"
    />
  </BaseFormItem2>
</template>

<script>
// 快递公司
import ExpressList2 from '@@/components/expressSelect/list2'

import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    express: {
      type: [String, Number],
      default: ''
    },
    // 快递名称展示(前端字段)
    view_express: {
      type: String,
      default: ''
    },
    // 预估重量
    weight: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    ExpressList2
  },
  data() {
    return {
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('express')
    },
    fillTips() {
      return !this.express
    }
  },
  // mounted() {
  //   this.init()
  // },
  methods: {
    init() {
      this.$refs.expressListRef.getList()
    },
    handleChange(data) {
      this.$emit('update:view_express', (data || {}).shipping_name)
      this.$emit('change', data)
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.express {
  ::v-deep .base-form-item__content {
    width: calc(100% - 110px);
  }
  .express__labelExtend {
    width: 100%;
    line-height: 16px;
    font-size: 13px;
    color: #999999;
    text-align: left;
  }
}
</style>